import React from 'react'
import { InputGroup, Glyphicon } from 'react-bootstrap'
import styled, { withTheme } from 'styled-components'
import Input from '../SearchBar/Input'
import { messages } from './messages'
import PropTypes from 'prop-types'

const Wrapper = styled.div`
  padding-top: 51px;
  width: 46%;
  margin: 0 auto;
  z-index: 20 !important;
  display: ${props => props.theme.getOption('expressHelp.faqFilter', 'none')};
`

const StyledGlyphicon = styled(Glyphicon)`
  color: #686868;
  font-size: 40px;
  cursor: pointer;

  :hover,
  :focus {
    color: var(--clr-accent-to-black);
  }
`

const FilterInput = ({
  handleChange,
  clearInputValue,
  inputValue,
  theme,
  language
}) => {
  const translated = messages[language]

  return (
    <Wrapper>
      <InputGroup>
        <Input
          style={{ height: '36px' }}
          placeholder={translated.filter}
          value={inputValue}
          onChange={handleChange}
        />
        <InputGroup.Addon>
          <StyledGlyphicon
            tabIndex="1"
            aria-label="clear input"
            theme={theme}
            glyph="remove"
            onClick={clearInputValue}
          />
        </InputGroup.Addon>
      </InputGroup>
    </Wrapper>
  )
}

FilterInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  clearInputValue: PropTypes.func.isRequired,
  inputValue: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
}

export default withTheme(FilterInput)



// WEBPACK FOOTER //
// ./src/components/ExpressHelp/ExpressFilterInput.js